export enum PadNumberType {
    DefaultType = 'default type',
    MetalsHardwareItem = 'metals hardware item',
    PlasticsProduct = 'plastics product',
    MetalsWorkOrder = 'metals work order',
    PlasticsFixture = 'plastics fixture',
    Procedure = 'procedure',
    ProcedureInstance = 'procedure instance',
    LaserProgram = 'laser program',
    MetalsLaserProgram = 'metals laser program',
    PlasticsOrder = 'plastics order',
    MetalsOrder = 'metals order',
    C3Order = 'c3 order',
}